import React, { useRef, useEffect, memo } from 'react';
import MarkdownContent from '../common/MarkdownContent';
import CopyButton from '../common/CopyButton';

const MessageList = memo(({ 
  messages, 
  currentMessage, 
  isLoading, 
  onRetry,
  errorMessage
}) => {
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, currentMessage]);

  return (
    <div className="messages">
      {messages.map((message, index) => (
        <div
          key={index}
          className={`message ${message.role === 'user' ? 'user' : 'assistant'}`}
        >
          <div className="message-content">
            {message.role === 'assistant' ? (
              <div className="assistant-message">
                <MarkdownContent content={message.content} />
                <CopyButton content={message.content} />
              </div>
            ) : (
              message.content
            )}
          </div>
          {message.role === 'user' && index === messages.length - 1 && errorMessage && (
            <div className="error-container">
              <div className="error-message">{errorMessage}</div>
              <button className="retry-button" onClick={onRetry}>
                重新生成
              </button>
            </div>
          )}
        </div>
      ))}
      {currentMessage && (
        <div className="message assistant">
          <div className="message-content">
            <div className="assistant-message">
              <MarkdownContent content={currentMessage} />
              <CopyButton content={currentMessage} />
            </div>
          </div>
        </div>
      )}
      {isLoading && !currentMessage && (
        <div className="loading">AI正在思考中...</div>
      )}
      <div ref={messagesEndRef} />
    </div>
  );
});

export default MessageList; 